import request from '@/utils/request'

export function getTransactionListApi(query) {
  return request({
    url: '/config-service/v1/transaction/transaction',
    method: 'get',
    params: query
  })
}

export function getTransactionListSimpleApi(query) {
  return request({
    url: '/config-service/v1/transaction/transaction/list-simple',
    method: 'get',
    params: query
  })
}
